import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { scrollDirection } from '../../foundation/utilities/scrollDirection';
import BaseFeature from '../../foundation/base/base';

class Header extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.log('Header Feature Init');

		this.classes = {
			navIsOpen: 'is-open'
		};
		this.scroll = {};

		this.initDomCache();
		this.init();
	}

	init() {
		this.dom.navController.addEventListener('click', () => {
			this.setNavIsOpen();
			this.dom.searchController.checked = false;
			this.dom.langController.checked = false;
		});
		this.dom.searchController.addEventListener('click', () => {
			this.dom.navController.checked = false;
			this.dom.langController.checked = false;
		});
		this.dom.langController.addEventListener('click', () => {
			this.dom.navController.checked = false;
			this.dom.searchController.checked = false;
		});
		// Set up scrolling events
		scrollDirection(window, false, this.el);

		// Listen to Viewport Scroll direction
		this.subscribe('window/scrollDirection', (data) => {
			// Test for overscrolling
			this.setPinned(data);
		});
	}

	setPinned(data) {
		const el = document.body;
		let scroll = window.scrollY;
		if (!scroll) {
			scroll = window.pageYOffset;
		}
		const dataScroll = this.el.getAttribute('data-header-scroll');
		// If top of screen
		if (scroll === 0 && dataScroll === 'compact') {
			this.el.removeAttribute('data-header-scroll', 'compact');
			this.el.setAttribute('data-header-scroll', 'fullsize');
		}
		// If not at top or bottom of screen
		if (scroll > 10 && !((window.innerHeight + window.pageYOffset) >= el.offsetHeight)) {
			if (data.detail === 'DOWN') {
				if (dataScroll === 'fullsize' || dataScroll === null) {
					this.el.removeAttribute('data-header-scroll', 'fullsize');
					this.el.setAttribute('data-header-scroll', 'compact');
				}
			} else if (dataScroll === 'compact' || dataScroll === null) {
				this.el.removeAttribute('data-header-scroll', 'compact');
				this.el.setAttribute('data-header-scroll', 'fullsize');
			}
		}
	}

	navIsOpen() {
		return this.dom.navController.checked;
	}

	setNavIsOpen() {
		const isNavOpen = this.navIsOpen();

		// Toggle the class based on our test
		this.el.classList.toggle(this.classes.navIsOpen, isNavOpen);

		// Lock scrolling on body
		if (isNavOpen) {
			disableBodyScroll(this.dom.navPanel);
		} else {
			clearAllBodyScrollLocks();
		}
	}
}

export default Header;
